
import { useNavigate } from "react-router-dom";
import { openPopUp } from "../components/popUp";
import Table from "../components/table";
import { TableElementProps } from "../components/tableElement";
import { useSafeNavigate } from "../components/unloadBlocker";
import { PayoutResponseDTO } from "../openapi-generated-client";
import { formatDate } from "../utils/dateUtils";
import PayOutInfoPopUp from "./popup/payoutInfoPopUp";

interface PayOutInfoTableProps {
    openRequests: PayoutResponseDTO[];
    closedRequests: PayoutResponseDTO[];
    refetch?: () => void;
}

export default function PayOutInfoTable(props: PayOutInfoTableProps) {

    const navigate = useSafeNavigate(useNavigate());
    
    return <Table
        className="payout-info-table"
        titles={["Date", "Date payed", "Account", "Amount"]}
        elementSwitch={[0, 1, 3, 2]}
        elements={[...props.openRequests.flatMap((e, i) => {
            var date = new Date(e.date);
            return [
                {
                    className: "date",
                    value: <>
                        <span className="no-style">{formatDate(date)}</span>
                    </>
                },
                {
                    className: "date",
                    value: <>
                        
                    </>
                },
                {
                    className: e.artistId > 0 ? "hover" : "",
                    blue: true,
                    onClick: () => {
                        navigate("/artists/" + e.artistId);
                    },
                    value: e.artist
                },
                {
                    className:"hover",
                    onClick: () => {
                        openPopUp(<PayOutInfoPopUp refetch={props.refetch} data={e} />);
                    },
                    blue: true,
                    value: e.amount
                }
            ];
        }) as TableElementProps[], "Previous Payouts", ...props.closedRequests.flatMap((e, i) => {
            var date = new Date(e.date), datePayed = e.closedDate ? new Date(e.closedDate) : undefined;
            return [
                {
                    className: "date",
                    value: <>
                        <span className="no-style">{formatDate(date)}</span>
                    </>
                },
                {
                    className: "date green",
                    value: <>
                        <span className="no-style">{datePayed ? formatDate(datePayed) : "-"}</span>
                    </>
                },
                {
                    className: e.artistId > 0 ? "hover" : "",
                    blue: true,
                    onClick: () => {
                        navigate("/artists/" + e.artistId);
                    },
                    value: e.artist
                },
                {
                    className:"hover",
                    onClick: () => {
                        openPopUp(<PayOutInfoPopUp refetch={props.refetch} data={e} />);
                    },
                    blue: true,
                    value: e.amount
                }
            ];
        }) as TableElementProps[]]}
    />;
}